import { Box, Typography, Stack } from "@mui/material";
import { useParams as useRouterParams } from "react-router";
import { useGetContentModelQuery } from "../../../../../../shell/services/instance";
import { ContentBreadcrumbs } from "../../components/ContentBreadcrumbs";
import { ItemListActions } from "../ItemList/ItemListActions";
import CSVImportBody from "./CSVImportBody";
export const CSVImport = ({
  ...routerProps
}) => {
  const {
    modelZUID
  } = useRouterParams<{
    modelZUID: string;
  }>();
  const {
    data: model
  } = useGetContentModelQuery(modelZUID);
  return <>
      <Stack direction="row" px={4} pt={4} pb={2} justifyContent="space-between" alignItems="start" color="text.primary" data-sentry-element="Stack" data-sentry-source-file="index.tsx">
        <Stack data-sentry-element="Stack" data-sentry-source-file="index.tsx">
          <ContentBreadcrumbs data-sentry-element="ContentBreadcrumbs" data-sentry-source-file="index.tsx" />
          <Typography variant="h3" mt={0.25} fontWeight={700} sx={{
          display: "-webkit-box",
          WebkitLineClamp: "2",
          WebkitBoxOrient: "vertical",
          wordBreak: "break-word",
          wordWrap: "break-word",
          hyphens: "auto",
          overflow: "hidden"
        }} data-sentry-element="Typography" data-sentry-source-file="index.tsx">
            {model?.label}
          </Typography>
        </Stack>
        <ItemListActions data-sentry-element="ItemListActions" data-sentry-source-file="index.tsx" />
      </Stack>

      <Box px={4} pt={2} bgcolor="grey.50" data-sentry-element="Box" data-sentry-source-file="index.tsx">
        <CSVImportBody {...routerProps} data-sentry-element="CSVImportBody" data-sentry-source-file="index.tsx" />
      </Box>
    </>;
};